import BaseMetricHandler from "./BaseMetricHandler";
import { echartsColorScheme } from "../../constants";

export default class WandUsageDataHandler extends BaseMetricHandler {
  constructor(groupBy, filterBy) {
    super(groupBy, filterBy);
    this.graphType = "";
    this.dataType = "counts";
  }

  getGraphOptions(backendData) {
    return this.getGraphOptionsForStackChart(backendData);
  }

  getGraphOptionsForStackChart(backendData) {
    let colors = ["#27A568", "#ED4C4C", "#F8A601", "#2A85F2", "#C70202"];
    let series = backendData.data
      .map((series, index) => {
        return {
          name: backendData.labels[index],
          type: "bar",
          stack: true,
          data: series,
          color: colors[index],
        };
      })
      .slice(0, BaseMetricHandler.MaxLabels());

    let options = {
      notMerge: true,
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: backendData.labels.slice(0, BaseMetricHandler.MaxLabels()),
        top: "bottom",
      },
      grid: {
        left: "0%",
        right: "0%",
        bottom: "20%",
        containLabel: true,
      },
      // toolbox: {
      //   feature: {
      //     saveAsImage: {},
      //   },
      // },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: backendData.xAxis,
      },
      yAxis: {
        type: "value",
      },
      series: series,
    };
    return options;
  }
}
